angular.module('dnecom')
    .directive('currencyDisplay', function () {
        var self = this;
        self.leftSideAppearance = ['usd', 'gbp', 'cad', 'aud', 'eur', 'rub', 'php'];
        self.charList = {
            'usd': '$',
            'gbp': '£',
            'cad': '$',
            'aud': '$',
            'eur': '€',
            'rub': '₽',
            'php': '₱'
        };

        return {
            restrict: 'E',
            scope: {
                value: '=',
                currency: '=',
            },

            template: '<span>{{ display() }}</span>',
            controller: ["$scope", function($scope) {
                $scope.display = function(){
                    currency = self.charList[$scope.currency.toLowerCase()] || $scope.currency.toUpperCase();
                    return self.leftSideAppearance.includes($scope.currency.toLowerCase())
                        ? currency + $scope.value
                        : $scope.value + ' ' + currency;
                };
            }],
            replace: true,
        };
    });

